import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import RCSelect, { Option as Option$1 } from 'rc-select';
import { DeleteCircleFilled, ArrowDownTinyFilled, CloseOutlined } from '@teko-builder/icons';

const normalize = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const normalizeLowerCase = (str) => normalize(str).toLowerCase();
const filterOptionSelect = (input, option) => normalizeLowerCase(option.children || option.label || '').indexOf(normalizeLowerCase(input)) >= 0;
const Select = (props) => {
    const { size = 'default', className, dropdownClassName, filterOption = filterOptionSelect, clearIcon = jsx(DeleteCircleFilled, { style: { fontSize: 16 } }), inputIcon = jsx(ArrowDownTinyFilled, { style: { fontSize: 14 } }), removeIcon = jsx(CloseOutlined, { style: { fontSize: 16 } }), bordered = true } = props, rest = __rest(props, ["size", "className", "dropdownClassName", "filterOption", "clearIcon", "inputIcon", "removeIcon", "bordered"]);
    const getClassName = () => {
        let cls = `rc-${size}`;
        if (className) {
            cls += ` ${className}`;
        }
        if (!bordered) {
            cls += ' borderless';
        }
        return cls;
    };
    const getDropdownClassName = () => {
        let cls = `rc-${size}`;
        if (dropdownClassName) {
            cls += ` ${dropdownClassName}`;
        }
        return cls;
    };
    return (jsx(RCSelect, Object.assign({ className: getClassName(), dropdownClassName: getDropdownClassName(), clearIcon: clearIcon, inputIcon: inputIcon, removeIcon: removeIcon, filterOption: filterOption }, rest)));
};
const Option = Option$1;

export { Option as O, Select as S };
